module.exports = __webpack_public_path__ + "img/33_BF11_dump_your_disposables.0faf1171.jpg";